import { useTranslation } from "react-i18next";
import KeyValue from "../../common/KeyValue";

export function QueStats({question}){
    const {t}=useTranslation();
    const stats1=[
        {key:t('Responses'),value:question.cntRespond},
        {key:t('Correct'),value:question.cntCorrect},
        {key:t('Wrong'),value:question.cntWrong},
        {key:t('Blank'),value:question.cntBlank}
    ]
    const stats2=[
        {key:t('Difficulty'),value:question.itemDiff},
        {key:t('Discrimination'),value:question.itemDiscr},
        {key:t('StDev'),value:question.itemStd},
        {key:t('Quality'),value:question.itemQuality}
    ]
    const stats3=[
        {key:'IRT-A',value:question.irtA},
        {key:'IRT-B',value:question.irtB},
        {key:'IRT-C',value:question.irtC}
    ]
    return(
        <>
            <div className="grid m-0 mt-2">   
                <div className="col"><KeyValue values={stats1}></KeyValue></div>
                <div className="col"><KeyValue values={stats2}></KeyValue></div>
                <div className="col"><KeyValue values={stats3}></KeyValue></div>
            </div>
        </>
    )
}